export default "__VITE_ASSET__CL$V9OEg__"